import { types } from "mobx-state-tree"

const RallySafeStage = types.model('RallySafeStage', {
    id: types.identifierNumber,
    name: types.string,
})

export default RallySafeStage
